/* ============================================================================
   PRESSROOM — MANIFESTO davranisi (FAZ 2 Parti 2, spec 3.6)
   <pressroom-manifesto> web component.
   - Desktop (>=750px, no-reduced, GSAP+ST var): iki serit ZIT yon scroll-scrub
     (CSS keyframes kapatilir, .is-scrubbed). Imza scroll belli noktada bir kez
     cizilir (stroke-dashoffset trigger, scrub degil).
   - Mobil / GSAP yoksa: CSS keyframes serit kaymasi kalir; imza tek seferlik
     fade-in (IO ile .is-faded).
   - reduced-motion: hicbir animasyon kurma; seritler+imza son durumda statik (CSS).

   Kurallar: hardcoded yok (sure CSS token'dan / GSAP defaults). Pin/scrub yalniz
   >=990 degil — burada scrub hafif, ama scrub yalniz fine+desktop'ta kurulur.
   ============================================================================ */
(function () {
  'use strict';

  if (!('customElements' in window)) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readToken(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  }

  customElements.define('pressroom-manifesto', class extends HTMLElement {
    connectedCallback() {
      this._section = this.querySelector('.pr-mani');
      this._tracks = Array.prototype.slice.call(this.querySelectorAll('[data-pr-mani-track]'));
      this._sig = this.querySelector('[data-pr-mani-signature]');
      this._sigPath = this.querySelector('.pr-mani__sig-path');
      if (!this._section) return;

      // Imza path uzunlugunu olc -> dash uzunlugu CSS var'a yaz (cizim icin).
      this._measureSignature();

      // reduced-motion: CSS zaten statik son durumu veriyor; hicbir sey kurma.
      if (REDUCED) return;

      var desktop = window.matchMedia('(min-width: 750px) and (pointer: fine)').matches;
      var hasST = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';

      if (desktop && hasST) {
        this._initScrub();
      } else {
        // Mobil / dokunma / GSAP yok: CSS keyframes serit kaymasi kalir.
        // Imzayi gorununce goster (mobilde fade, desktop'ta path cizimi mumkunse).
        this._initSignatureIO(desktop);
      }
    }

    disconnectedCallback() {
      if (this._triggers) {
        this._triggers.forEach(function (t) { if (t && t.kill) t.kill(); });
      }
      if (this._sigIO) this._sigIO.disconnect();
    }

    _measureSignature() {
      if (!this._sigPath || typeof this._sigPath.getTotalLength !== 'function') return;
      try {
        var len = Math.ceil(this._sigPath.getTotalLength());
        if (len > 0) this._sigPath.style.setProperty('--pr-sig-len', len);
      } catch (e) { /* getTotalLength yoksa CSS fallback var devrede */ }
    }

    _initScrub() {
      var gsap = window.gsap;
      var ST = window.ScrollTrigger;
      gsap.registerPlugin(ST);
      this._section.classList.add('is-scrubbed'); // CSS keyframes'i kapat

      this._triggers = [];
      var self = this;

      // Serit scrub mesafesi: token --mv-parallax tabanli; serit genisligine gore.
      // Her serit kendi yonunde scroll ilerledikce kayar (zit).
      this._tracks.forEach(function (track) {
        var strip = track.closest('[data-pr-mani-strip]');
        var dir = strip && strip.getAttribute('data-pr-mani-strip') === 'bottom' ? 1 : -1;
        // Kayma miktari: track'in tasan yarisi kadar (sonsuz his) — px.
        var overflow = (track.scrollWidth - self._section.clientWidth) || track.scrollWidth * 0.4;
        var amount = overflow * 0.5 * dir;
        // Baslangici ortala (zit yon okunur)
        gsap.set(track, { x: -amount * 0.5 });
        var tl = gsap.to(track, {
          x: amount * 0.5,
          ease: 'none',
          scrollTrigger: {
            trigger: self._section,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
          }
        });
        self._triggers.push(tl.scrollTrigger);
      });

      // Imza: scroll belli noktaya gelince BIR KEZ cizilir (trigger, scrub degil).
      if (this._sig) {
        var sigTl = ST.create({
          trigger: self._section,
          start: 'center 65%',
          once: true,
          onEnter: function () { self._sig.classList.add('is-drawn'); }
        });
        this._triggers.push(sigTl);
      }
    }

    _initSignatureIO(desktop) {
      var self = this;
      if (!this._sig || !('IntersectionObserver' in window)) {
        // Gozlemci yok: dogrudan goster.
        if (this._sig) { this._sig.classList.add('is-drawn'); this._sig.classList.add('is-faded'); }
        return;
      }
      this._sigIO = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Desktop: path cizimi; mobil: fade (CSS mobilde dashoffset 0 zaten).
            self._sig.classList.add(desktop ? 'is-drawn' : 'is-faded');
            // Mobilde de is-drawn ekle (guvenli; CSS mobilde offset 0).
            self._sig.classList.add('is-faded');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      this._sigIO.observe(this._sig);
    }
  });
})();
